import { render } from "./TrainingsBlock.vue?vue&type=template&id=70f96f2a&scoped=true"
import script from "./TrainingsBlock.vue?vue&type=script&lang=js"
export * from "./TrainingsBlock.vue?vue&type=script&lang=js"

import "./TrainingsBlock.vue?vue&type=style&index=0&id=70f96f2a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f96f2a"]])

export default __exports__